class ReactFormatterRecurringType extends React.Component {

    constructor(props) {
        super(props);
    }

    render(){

        var i = this.props.record.getIn(['ContributionRecurringBatch','recurring_interval']);
        var p = this.props.record.getIn(['ContributionRecurringBatch','recurring_period']);
        
        var type = '';
        
        if (i && p) {
            p = p.charAt(0).toUpperCase() + p.slice(1);
            type=  i+' '+(i==1?p:p+'s');
        } else {
        }
        
        return (
            <span>
                {type}
            </span>
        )
    }
}

ReactFormatterRecurringType.defaultProps = {
    value: false
};

class ReactFormatterPersonGroup extends  React.Component{

    constructor(props) {
        super(props);
    }

    render(){
        
        var groupName = '-';
        
        if(this.props.record.getIn(['Person','is_group'])){
            groupName = this.props.record.getIn(['Person','fullname'])
        }

        return (
            <span>
                {groupName}
            </span>
        )
    }
}

ReactFormatterPersonGroup.defaultProps = {
    value: false
};

class ReactFormatterRecurringStatus extends  React.Component{

    constructor(props) {
        super(props);
        this.statusText = {
            0:'Canceled',
                1:'Active',
                2:'Hold'
        };
    }

    render(){

        var status = this.props.record.getIn(['ContributionRecurringBatch','active']);

        var type = this.statusText[status];

        return (
            <span>
                {type}
            </span>
        )
    }
}

ReactFormatterRecurringStatus.defaultProps = {
    value: false
};